import { useCommonQuery } from "./common-query";

export const useTopNavigation = () => {
    const { telerikNavigation } = useCommonQuery();

    return telerikNavigation;
} 